import { render, staticRenderFns } from "./CentralizedManager.vue?vue&type=template&id=6ebd5ea8"
import script from "./CentralizedManager.vue?vue&type=script&lang=js"
export * from "./CentralizedManager.vue?vue&type=script&lang=js"
import style0 from "./CentralizedManager.vue?vue&type=style&index=0&id=6ebd5ea8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports